import React from 'react';
import { IconProps } from '.';

const SvgCircleQuestion = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 7.75c-.943 0-1.75.84-1.75 1.875h-1.5C8.75 7.86 10.133 6.25 12 6.25c1.725 0 3.36 1.533 3.244 3.421-.045.736-.345 1.318-.695 1.791a9.925 9.925 0 0 1-.823.933l-.237.249-.01.01-.01.01-.002.004-.021.02a3.69 3.69 0 0 0-.353.446c-.21.314-.343.626-.343.866h-1.5c0-.694.337-1.314.597-1.701a5.215 5.215 0 0 1 .506-.637c.016-.018.03-.031.04-.041l.005-.006c.107-.116.21-.222.306-.322.242-.253.452-.471.64-.724.24-.326.381-.634.403-.99.06-.963-.823-1.829-1.747-1.829ZM11.25 17.3v-1.7h1.5v1.7h-1.5Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 21.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19Zm0 1.5c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCircleQuestion;
